import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories, MAIN_SITE_URL } from '@/mocks/categories';

export default function Footer() {
  const { t, i18n } = useTranslation();

  const resourceLinks = [
    { key: 'footer_guides', hash: '#guides' },
    { key: 'footer_reviews', hash: '#info' },
    { key: 'footer_shipping', hash: '#info' },
    { key: 'footer_safety', hash: '#safety' },
    { key: 'footer_faq', hash: '#faq' },
  ];

  const legalLinks = [
    { key: 'footer_privacy', href: '/' },
    { key: 'footer_terms', href: '/' },
    { key: 'footer_disclaimer', href: '/' },
  ];

  const languageCodes = [
    { code: 'en', label: 'English' },
    { code: 'pl', label: 'Polski' },
    { code: 'es', label: 'Español' },
    { code: 'fr', label: 'Français' },
  ];

  return (
    <footer className="bg-secondary-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
                <i className="ri-grid-fill text-lg"></i>
              </span>
              <span className="text-base font-bold text-foreground-900 whitespace-nowrap">
                {t('brand_name')}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">{t('footer_tagline')}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">{t('footer_resources')}</h4>
            <ul className="mt-4 space-y-2">
              {resourceLinks.map((link) => (
                <li key={link.key}>
                  <Link
                    to={`/${link.hash}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700 cursor-pointer"
                  >
                    {t(link.key)}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/article/usfans-spreadsheet-guide"
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-700 cursor-pointer"
                >
                  {t('footer_guides')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">{t('footer_company')}</h4>
            <ul className="mt-4 space-y-2">
              <li>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-700 cursor-pointer"
                >
                  {t('nav_mainWebsite')}
                </a>
              </li>
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.link}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700 cursor-pointer"
                  >
                    {t(cat.nameKey)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">{t('footer_languages')}</h4>
            <ul className="mt-4 space-y-2">
              {languageCodes.map((lang) => (
                <li key={lang.code}>
                  <button
                    type="button"
                    onClick={() => i18n.changeLanguage(lang.code)}
                    className={`text-sm transition-colors cursor-pointer ${
                      i18n.language === lang.code
                        ? 'font-semibold text-primary-700'
                        : 'text-foreground-600 hover:text-primary-700'
                    }`}
                  >
                    {lang.label}
                  </button>
                </li>
              ))}
            </ul>
            <h4 className="mt-6 text-sm font-semibold text-foreground-900">{t('footer_legal')}</h4>
            <ul className="mt-4 space-y-2">
              {legalLinks.map((link) => (
                <li key={link.key}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700 cursor-pointer"
                  >
                    {t(link.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-300 pt-6">
          <p className="text-xs leading-relaxed text-foreground-500">{t('footer_disclaimer_text')}</p>
          <p className="mt-4 text-xs text-foreground-500">{t('footer_copyright')}</p>
        </div>
      </div>
    </footer>
  );
}